module.exports = __webpack_public_path__ + "img/symbol_7.1b642ecb.png";